const TASK_LOG_DATE_FIELDS = new Set(['ExpiryDate']);

export function taskLogFieldTranslationKey(fieldName: string): string {
  if (!fieldName) {
    return fieldName;
  }

  return fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
}

export function isTaskLogDateField(fieldName: string): boolean {
  return TASK_LOG_DATE_FIELDS.has(fieldName) || fieldName.endsWith('Date');
}

export function isTaskLogDateValue(value: string | null | undefined): boolean {
  if (!value) {
    return false;
  }

  return /^\d{4}-\d{2}-\d{2}/.test(value) && !Number.isNaN(Date.parse(value));
}
